<script setup lang="ts">
/**
 * Footer V2 — "Feito com 💚 para brasileiros"
 *
 * Reusa exatamente a mesma fonte do footer legado (FooterBrazilians):
 *   - Bandeira: /assets/images/countries/{COUNTRY}.png
 *   - Texto: i18n footer.made_with_love[_mex|_pry] (varia por país)
 *   - Coração: 💚 (BRA) / ❤️ (MEX) / 💙 (PRY)
 */

const { t } = useTexts();
const { visitorOrUserCountry } = useParameters();

const flagSrc = computed(() => {
  return getAssetsUrlForCDN(
    `/assets/images/countries/${visitorOrUserCountry.value}.png`,
  );
});

const fallbackFlagSrc = computed(() => {
  return getAssetsUrlForCDN('/assets/images/countries/XXX.png');
});

const textOnParagraph = computed(() => {
  if (visitorOrUserCountry.value === 'MEX') {
    return t('footer.made_with_love_mex', { heart: '<small>❤️</small>' });
  }
  if (visitorOrUserCountry.value === 'PRY') {
    return t('footer.made_with_love_pry', { heart: '<small>💙</small>' });
  }

  return t('footer.made_with_love', { heart: '<small>💚</small>' });
});

const show = computed(() => !!visitorOrUserCountry.value);
</script>

<template>
  <div
    v-if="show"
    class="footer-v2-brazilians"
  >
    <BaseCommonCustomNuxtImg
      :alt="visitorOrUserCountry"
      class="footer-v2-brazilians__flag"
      :src="flagSrc"
    >
      <template #fallback>
        <img
          :alt="visitorOrUserCountry"
          class="footer-v2-brazilians__flag"
          height="20"
          :src="fallbackFlagSrc"
          width="30"
        />
      </template>
    </BaseCommonCustomNuxtImg>

    <p
      class="footer-v2-brazilians__text"
      v-html="textOnParagraph"
    ></p>
  </div>
</template>

<style scoped lang="scss">
.footer-v2-brazilians {
  display: flex;
  width: 100%;
  max-width: 353px;
  height: 40px;
  /* Centraliza o bloco no eixo cross do .footer-v2 (flex-col stretch). */
  align-self: center;
  justify-content: center;
  align-items: center;
  gap: 10px;

  &__flag {
    height: 20px;
    width: auto;
    border-radius: 4px;
    flex-shrink: 0;
  }

  &__text {
    margin: 0;
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 163.636% */
    text-align: center;

    /* O coração vem dentro de <small> via v-html; deixamos no
       mesmo tamanho do texto para alinhamento visual. */
    :deep(small) {
      font-size: inherit;
      line-height: inherit;
    }
  }
}
</style>
